import { RenderTargetFormat } from "../RenderEngine/RenderEnum/RenderTargetFormat";
import { Color } from "../maths/Color";
import { Vector2 } from "../maths/Vector2";
import { Vector4 } from "../maths/Vector4";
import { RenderTexture2D } from "../resource/RenderTexture2D";
import { ShaderDefines2D } from "../webgl/shader/d2/ShaderDefines2D";
import { TextureSV } from "../webgl/shader/d2/value/TextureSV";
import { Filter } from "./Filter";
var _definiteIntegralMap = {};
export class BlurFilter extends Filter {
    constructor(strength = 4) {
        super();
        this.shaderData = new TextureSV();
        this._shaderV1 = new Vector4();
        this.strength = strength;
    }
    get strength() {
        return this._strength;
    }
    set strength(v) {
        this._strength = Math.max(Math.abs(v), 2);
        var sigma = this._strength / 3.0;
        var sigma2 = sigma * sigma;
        let v1 = this._shaderV1 = new Vector4(this.strength, sigma2, 2.0 * sigma2, 1.0 / (2.0 * Math.PI * sigma2));
        let s = 0;
        let key = Math.floor(this.strength * 10);
        if (_definiteIntegralMap[key] != undefined) {
            s = _definiteIntegralMap[key];
        }
        else {
            for (let y = -4; y <= 4; ++y) {
                for (let x = -4; x <= 4; ++x) {
                    s += v1.w * Math.exp(-(x * x + y * y) / v1.z);
                }
            }
            _definiteIntegralMap[key] = s;
        }
        v1.w /= s;
        this.onChange();
    }
    render(srctexture, width, height) {
        let marginLeft = 50;
        let marginTop = 50;
        this.left = -marginLeft;
        this.top = -marginTop;
        let texwidth = width + 2 * marginLeft;
        let texheight = height + 2 * marginTop;
        this.width = texwidth;
        this.height = texheight;
        if (!this.texture || this.texture.destroyed || this.texture.width != texwidth || this.texture.height != texheight) {
            if (this.texture)
                this.texture.destroy();
            this.texture = new RenderTexture2D(texwidth, texheight, RenderTargetFormat.R8G8B8A8);
        }
        let render2d = this._render2D.clone(this.texture);
        render2d.renderStart(true, new Color(0, 0, 0, 0));
        let rectVB = this._rectMeshVB;
        let stridef32 = this._rectMesh.vertexDeclarition.vertexStride / 4;
        rectVB[0] = marginLeft;
        rectVB[1] = marginTop;
        rectVB[stridef32] = marginLeft + width;
        rectVB[stridef32 + 1] = marginTop;
        rectVB[stridef32 * 2] = marginLeft + width;
        rectVB[stridef32 * 2 + 1] = marginTop + height;
        rectVB[stridef32 * 3] = marginTop;
        rectVB[stridef32 * 3 + 1] = marginTop + height;
        let shadersv = this.shaderData;
        shadersv.shaderData.addDefine(ShaderDefines2D.FILTERBLUR);
        shadersv.size = new Vector2(texwidth, texheight);
        shadersv.textureHost = srctexture;
        shadersv.blurInfo = new Vector2(texwidth, texheight);
        shadersv.strength_sig2_2sig2_gauss1 = this._shaderV1;
        render2d.draw(this._rectMesh, 0, 4 * this._rectMesh.vertexDeclarition.vertexStride, 0, 12, shadersv, null);
        render2d.renderEnd();
    }
}
